import React, { useState, useRef, useEffect } from 'react';
import { useParams } from 'react-router';
import { Button, Col, Select, Drawer, Form, Input, Row, Switch, Space, message, Modal, Typography, Mentions, Divider } from 'antd';
import { CloseOutlined, CheckOutlined, MoonFilled, SunFilled } from '@ant-design/icons';
import { getById, insert, update, getFormulasGlobales } from '../../../../apis/FormulasGlobalesApi';
import Editor from '@monaco-editor/react';
import AnioPeriodo from '../../../../components/forms/anio_periodo';
import { defFunction, declareFuncionInicio, declareFuncionFin, codeInit } from '@app/constants/definition_python';
import _ from 'lodash';
const { Option } = Select;

const App = ({ title, id, open, finish }) => {
    const [form] = Form.useForm()
    const [formTest] = Form.useForm()
    const [ID, setID] = useState(id);
    const [code, setCode] = useState(codeInit);
    const [showModal, setShowModal] = useState(false);
    const [modified, setModified] = useState(false);
    const [initialValues, setInitialValues] = useState(null);
    const [themeEditor, setThemeEditor] = useState('light');
    const [resultadoTest, setResultadoTest] = useState('');
    const [formulas, setFormulas] = useState([]);

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            if (!values) return;
        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
            return;
        }

        const fields = form.getFieldsValue()
        let success = false;
        let formula = editorRef.current.getValue();
        let selectedTipoFormula = parseInt(fields.tipo_formula, 10);
        if (ID > 0) {
            //Update
            const payload = {
                id: ID,
                ...fields,
                formula: formula,
                tipo_formula: selectedTipoFormula

            }
            const response = await update(payload);
            success = response.ok;
            if (response.ok) {
                message.success('Se actualizó correctamente la formula!');
                setModified(true);
            }
        } else {
            //Create
            const payload = {
                id: ID,
                ...fields,
                formula: formula,
                tipo_formula: selectedTipoFormula
            }
            const response = await insert(payload);
            success = response.ok;
            if (response.ok) {
                setID(response.payload);
                message.success('Se guardo correctamente la formula!');
                setModified(true);
            }
        }

        if (success) {
            //setShowModal(false);
            //finish(true);
        }
    }

    const onClose = (reload) => {
        finish(reload ?? modified);
        setInitialValues(null);
    }

    const effectRan = useRef(false);
    useEffect(() => {
        if (!effectRan.current) {
            (async () => {
                //await refreshVariables();
                
                // Cargar las fórmulas globales primero
                try {
                    const response = await getFormulasGlobales();
                    setFormulas(response);
                } catch (error) {
                    console.error('Error cargando fórmulas:', error);
                }
                
                // Luego cargar los datos específicos si hay ID
                if (ID > 0) {
                    await refreshData();
                } else {
                    setInitialValues({
                        activo: true,
                        formula: codeInit,
                        tipo_formula: null
                    });
                }
                setModified(false)
            })();
        }
        return () => effectRan.current = true;
    }, []);

    React.useEffect(() => {
        setShowModal(open);
    }, [open]);

    const onChangeTipoFormula = (value) => {
        console.log('Formula seleccionada:', value);
    };

    const refreshData = async () => {
        const response = await getById(ID);
        if (response.ok) {
            let payload = response.payload;
            setInitialValues(payload);
            setCode(payload.formula)
        }
    }

    const editorRef = useRef(null);

    // function handleEditorChange(editor, monaco) {
    //     editorRef.current = editor;
    // }

    function handleEditorDidMount(editor, monaco) {
        editorRef.current = editor;
    }

    function getName() {
        const fields = form.getFieldsValue()
        let newName = fields.descripcion.replaceAll(" ", "_");
        return newName;
    }

    const onChangeName = async () => {
        let newName = getName();
        let currentCode = editorRef.current.getValue();
        let newDefFunction = 'def ' + newName + '():';
        let currentDefinition = (currentCode.split(declareFuncionInicio)[1] || "").split(declareFuncionFin)[0];
        if (currentDefinition == defFunction) {
            currentCode = currentCode.replace(currentDefinition, `${declareFuncionInicio}\n${newDefFunction}\n${declareFuncionFin}`)
        } else {
            currentCode = currentCode.replace(currentDefinition, `\n${newDefFunction}\n`)
        }
        editorRef.current.getModel().setValue(currentCode);
        // setCode(currentCode);
    }

    const onChangeTheme = async (value) => {
        setThemeEditor(value ? 'light' : 'vs-dark');
    }

    const handleTestOk = async () => {
        let success = false;
        const fields = formTest.getFieldsValue()
        //Test
        let functionName = getName();
        const payload = {
            formula_id: ID,
            function_name: functionName,
            ...fields
        }
    }

    return (
        <Drawer
            title={title}
            width={'100%'}
            placement={"right"}
            onClose={onClose}
            open={true}
            closable={true}
            extra={[
                <Space>
                    <Button onClick={onClose}>Cancelar</Button>
                    <Button onClick={handleOk} type="primary">
                        Guardar
                    </Button>
                </Space>]}
        >
            <>
                {
                    initialValues &&
                    <Form
                        layout="vertical"
                        form={form}
                        requiredMark
                        autoComplete="off"
                        initialValues={initialValues}
                        onFinish={handleOk}>
                        <Row gutter={16}>
                            <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                <Row gutter={16}>
                                    <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                        <Form.Item
                                            name="descripcion"
                                            label="Descripción"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Por favor agrega una descripción',
                                                },
                                            ]}
                                        >
                                            <Input placeholder="Por favor agrega una descripción" />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                        <Form.Item
                                            name="tipo_formula"
                                            label="Tipo de Formula"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Por favor agrega el tipo de formula',
                                                },
                                            ]}
                                        >
                                            <Select
                                                value={initialValues?.tipo_formula} 
                                                placeholder="Por favor agrega una descripción"
                                                showSearch
                                                filterOption={(input, option) =>
                                                    (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                                }
                                                onChange={onChangeTipoFormula}
                                            >
                                                <Option value="">Ninguno</Option>
                                                {formulas.map((item) => (
                                                    <Option key={item.Value} value={item.Value}>
                                                        {item.Name}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                        <Form.Item
                                            name="activo"
                                            label="Activo"
                                        >
                                            <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    {
                                        ID > 0 && <>
                                            <Divider orientation="left">Prueba</Divider>
                                            <Form
                                                layout="vertical"
                                                form={formTest}
                                                requiredMark
                                                autoComplete="off"
                                                onFinish={handleTestOk}>
                                                <AnioPeriodo form={formTest} disabledForm={false} />
                                                <br />
                                                <Form.Item>
                                                    <Space>
                                                        <Button onClick={handleTestOk}>
                                                            Probar
                                                        </Button>
                                                    </Space>
                                                </Form.Item>
                                                <br />
                                                <Form.Item>
                                                    <Space>
                                                        Resultado: {resultadoTest}
                                                    </Space>
                                                </Form.Item>
                                            </Form>
                                        </>
                                    }
                                </Row>
                            </Col>
                            <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                                <Row gutter={16}>
                                    <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }} style={{ marginBottom: 20, marginLeft: 20 }}>
                                        Color del editor
                                        <Switch defaultChecked checkedChildren={<SunFilled />} unCheckedChildren={<MoonFilled />} onChange={onChangeTheme} style={{ marginLeft: 20 }} />
                                    </Col>
                                </Row>
                                <Editor
                                    height="90vh"
                                    defaultLanguage="python"
                                    defaultValue={initialValues.formula}
                                    theme={themeEditor}
                                    options={{
                                        inlineSuggest: true,
                                        fontSize: "16px",
                                        formatOnType: true,
                                        autoClosingBrackets: true,
                                        minimap: { scale: 10 }
                                    }}
                                    onMount={handleEditorDidMount}
                                />
                            </Col>
                        </Row>
                    </Form>
                }
            </>
        </Drawer>
    );
};
export default App;